export const API_BASE = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8080";

/** Shown in the Rate limit column of every pricing table. */
export const RATE_LIMIT = "200/min";

// The product/dashboard lives on its own subdomain (app.encrata.com) in the
// separate `encrata` repo. Auth CTAs on the marketing site link out to it.
// In local dev the app runs on localhost:3000; set NEXT_PUBLIC_APP_URL to
// override either default.
export const APP_URL =
  process.env.NEXT_PUBLIC_APP_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://app.encrata.com");
